import config from '../../../config/config';
import { LoginAction } from '../types/LoginAction';
import { UserData } from '../types/UserData';

let userDataDefault: UserData = {
  isAuthenticated: false,
  authenticatedUser: null,
  selectedRoleIndex: 0,
  selectedRole: false,
  showErrorToast: false,
  loggedInUserData: null,
  isPostExpiryDays: false,
  showLicenseExpiredDialog: false,
  unregisteredDevicesData: null,
  alreadyLoggedInDeviceData: null,
};

function addDays(date:any, days:any) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function compare_dates(today:Date,endDate:Date, endDatePlusPostExpiry: Date){


  const todayDay = today.getDate();
  const todayMonth = today.getMonth() + 1;
  const todayYear = today.getFullYear();


  const endDateDay = endDate.getDate();
  const endDateMonth = endDate.getMonth() + 1;
  const endDateYear = endDate.getFullYear();


  const endDatePlusPostExpiryDay = endDatePlusPostExpiry.getDate();
  const endDatePlusPostExpiryMonth = endDatePlusPostExpiry.getMonth() + 1;
  const endDatePlusPostExpiryYear = endDatePlusPostExpiry.getFullYear();


  const checkWithEndDate = today.getTime() > endDate.getTime() ? true : false;
  //Check if today is greater than end date
  // if(todayYear > endDateYear ||
  //   todayMonth > endDateMonth ||
  //   todayDay > endDateDay){
  //     checkWithEndDate = true;
  //   } else {
  //     checkWithEndDate = false;
  //   }

  //Check if today is less than endate plus post expiry days
  let checkWithEndOfGrace;
    if(todayYear <= endDatePlusPostExpiryYear ||
      todayMonth <= endDatePlusPostExpiryMonth ||
      todayDay <= endDatePlusPostExpiryDay
      ) {
        checkWithEndOfGrace = true
      } else {
        checkWithEndOfGrace = false
      }

    return {checkWithEndDate, checkWithEndOfGrace}

}

const loginReducer = (
  state: UserData = userDataDefault,
  action: LoginAction
) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      //setting default image if profile image not found
      if (
        action.data.authenticatedUser &&
        !action.data.authenticatedUser.profileImage
      ) {
        action.data.authenticatedUser.profileImage =
          'assets/img/profile-default.png';
      }
      localStorage.setItem(config.localStorageKey, JSON.stringify(action.data));
      
      return { ...state, ...action.data, showErrorMsg: false, unregisteredDevicesData: null, alreadyLoggedInDeviceData: null };
    case 'LOGIN_FAILED':
      return { ...state, isAuthenticated: false , showErrorMsg: true};
    case 'LICENSE_EXPIRED':
      return { ...state, showErrorToast: true };
    case 'TOGGLE_LICENSE_EXPIRY_DIALOG':
      
      return {
        ...state,
        showLicenseExpiredDialog: action.data,
      };
    case 'LOGGED_IN_USER': {

      let userData: any = localStorage.getItem(config.localStorageKey);
      let userLicenseData;
      if (userData) {
        userData = JSON.parse(userData);
        userLicenseData = userData.authenticatedUser.clientId.license
        
      } 
      
      
      let today = new Date();
      let endDate = new Date(userLicenseData && userLicenseData.endDate);
      let endOfGracePeriodDate = addDays(userLicenseData && userLicenseData.endDate, userLicenseData && userLicenseData.postExpiryAccessibilityDays);
      
      const { checkWithEndDate, checkWithEndOfGrace } = compare_dates(today, endDate, endOfGracePeriodDate)

      
      if(userLicenseData && userLicenseData.postExpiryAccessibilityDays && 
        checkWithEndDate &&
        checkWithEndOfGrace
        ){
        
        return { ...state, loggedInUserData: userLicenseData, isPostExpiryDays: true };
      } 
      return { ...state, loggedInUserData: userLicenseData, isPostExpiryDays: false};
    }
    case 'LOGOUT_SUCCESS':
      
      localStorage.removeItem(config.localStorageKey);
      localStorage.removeItem('isFirstUser');
      return { ...state, ...action.data };
    case 'LOGOUT_FAILURE':
      return { ...state, ...action.data };
    case 'ROLE_SELECTED':
      let patmy: any = localStorage.getItem(config.localStorageKey);
      if (patmy) {
        patmy = JSON.parse(patmy);
        patmy.selectedRoleIndex = action.data.selectedRoleIndex;
        patmy.selectedRole = action.data.selectedRole;
        localStorage.setItem(config.localStorageKey, JSON.stringify(patmy));
      }
      return {
        ...state,
        selectedRoleIndex: action.data.selectedRoleIndex,
        selectedRole: action.data.selectedRole,
      };
    case 'SWITCH_ROLE':
      return { ...state, selectedRoleIndex: action.data.selectedRoleIndex };
    case 'LOAD_DATA':
      let data: any = localStorage.getItem(config.localStorageKey);
      if (data) {
        data = JSON.parse(data);
      } else {
        data = state;
      }
      return data;
    case 'REMOVE_ERROR_MSG':
      return { ...state, showErrorMsg: false };
    case 'UNREGISTERED_DEVICE':
        return { ...state, unregisteredDevicesData: action.data.unregisteredDeviceData, alreadyLoggedInDeviceData: null };
    case 'ALREADY_LOGGED_IN': 
      return { ...state, alreadyLoggedInDeviceData: action.data.alreadyLoggedInDeviceData, unregisteredDevicesData: null };
    default:
      return state;
  }
};

export default loginReducer;
